import { Theme, useMediaQuery } from '@mui/material';

export const useIsMobile = () => useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

export const useIsTablet = () => useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

export const useIsLargeTablet = () => useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
